import script from "./CustomTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomTab.vue?vue&type=script&setup=true&lang=ts"

import "./CustomTab.vue?vue&type=style&index=0&id=308b9b2f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-308b9b2f"]])

export default __exports__